import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('hero')}>
            <i className={`ri-ship-line text-3xl mr-2 ${isScrolled ? 'text-teal-500' : 'text-white'}`}></i>
            <span className={`text-2xl font-bold ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
              MarAzul
            </span>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('services')}
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-500' : 'text-white hover:text-teal-300'
              }`}
            >
              Servicios
            </button>
            <button
              onClick={() => scrollToSection('fleet')}
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-500' : 'text-white hover:text-teal-300'
              }`}
            >
              Flota
            </button>
            <button
              onClick={() => scrollToSection('experiences')}
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-500' : 'text-white hover:text-teal-300'
              }`}
            >
              Experiencias
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-500' : 'text-white hover:text-teal-300'
              }`}
            >
              Testimonios
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="px-6 py-2 bg-teal-500 hover:bg-teal-600 text-white font-semibold rounded-full transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Reservar
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white shadow-lg rounded-b-2xl py-4">
            <button
              onClick={() => scrollToSection('services')}
              className="block w-full text-left px-6 py-3 text-gray-700 hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer"
            >
              Servicios
            </button>
            <button
              onClick={() => scrollToSection('fleet')}
              className="block w-full text-left px-6 py-3 text-gray-700 hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer"
            >
              Flota
            </button>
            <button
              onClick={() => scrollToSection('experiences')}
              className="block w-full text-left px-6 py-3 text-gray-700 hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer"
            >
              Experiencias
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className="block w-full text-left px-6 py-3 text-gray-700 hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer"
            >
              Testimonios
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left px-6 py-3 text-teal-600 font-semibold hover:bg-teal-50 transition-colors cursor-pointer"
            >
              Reservar
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}
